export default __webpack_public_path__ + "static/media/baby-8.5ffaeb5b.svg";